import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import LfHeaderTitleComponent from '@/components/HeaderTitle/LfHeaderTitleComponent.vue'
import { ActionBarButton, ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import useRouter from '@/composables/useRouter'
import TabsComponent from '@/components/tabs/TabsComponent/TabsComponent.vue'
import { ContextName } from '@/store/types/storeGlobalTypes'
import { computed, ref } from 'vue'
import { defaultFilter } from '@/store/modules/alertsMessages/alertsMessagesTypes'
import useActionsFilteredAlertsMessages from '@/components/AlertsMessages/composables/useActionsFilteredAlertsMessages'
import useTabConfiguration from '@/composables/useTabConfiguration'
import { TabModel } from '@/components/tabs/TabsComponent/TabsComponentTypes'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsMessagesView',
  setup(__props) {

const { t } = useI18n()

const text = {
  actions: t('views.alerts_messages.actions'),
  actionsAlerts: t('views.alerts_messages.actions_alerts'),
  agenda: t('views.alerts_messages.agenda'),
  agendaAlerts: t('views.alerts_messages.agenda_alerts'),
  all: t('views.alerts_messages.all'),
  allAlerts: t('views.alerts_messages.all_alerts'),
  billingAlerts: t('views.alerts_messages.billing_alerts'),
  billings: t('views.alerts_messages.billings'),
  closeBtn: t('action_buttons.close'),
  expedientAlerts: t('views.alerts_messages.expedients_alerts'),
  expedients: t('views.alerts_messages.expedients'),
  igualaAlerts: t('views.alerts_messages.igualas_alerts'),
  igualas: t('views.alerts_messages.igualas'),
  lexnet: t('views.alerts_messages.lexnet'),
  lexnetAlerts: t('views.alerts_messages.lexnet_alerts')
}

const context = ContextName.ALERTS_MESSAGES
const allTabIndex: number = 0
const selectedTabIndex = ref<number>(allTabIndex)
const { goBack } = useRouter()
const { tabConfiguration, getTabConfiguration } = useTabConfiguration({
  aliasName: 'alerts',
  context
})
const { setFilter } = useActionsFilteredAlertsMessages()

const tabs = ref<TabModel[] | undefined>(undefined)
const texts = {
  buttons: {
    close: text.closeBtn
  }
}

const title = computed(() => {
  if (tabs.value === undefined) {
    return ''
  }
  return tabs.value[selectedTabIndex.value].title as string
})

const buttons: ActionBarButton[] = [
  {
    tooltip: texts.buttons.close,
    action: ActionName.CLOSE,
    enabled: true
  }
]

const onExecuteAction = async (actionName: string) => {
  ActionName.CLOSE === actionName ? goBack() : null
}

const onChangeTab = async (tabIndex: number, _objectType: string, _resolve: any) => {
  selectedTabIndex.value = tabIndex
  if (tabs.value !== undefined) {
    await setFilter({
      type: tabs.value[tabIndex].items[0].alertMessageType,
      page: 1
    })
  }
}

async function init() {
  await getTabConfiguration()
  tabs.value = tabConfiguration.value
}

init()

return { __sfc: true,t, text, context, allTabIndex, selectedTabIndex, goBack, tabConfiguration, getTabConfiguration, setFilter, tabs, texts, title, buttons, onExecuteAction, onChangeTab, init, LfHeaderTitleComponent, TabsComponent }
}

})